import script from "./VolumeSetting.vue?vue&type=script&setup=true&lang=ts"
export * from "./VolumeSetting.vue?vue&type=script&setup=true&lang=ts"

import "./VolumeSetting.vue?vue&type=style&index=0&id=81195440&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/deployJob/project/music-teach/h5-internal-examination/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81195440"]])

export default __exports__